import {BrowserRouter,Routes,Route,useLocation} from "react-router-dom";
import {Box,Container} from "@mui/material";
import CorrentistaForm from "./components/CorrentistaForm";
import CorrentistaList from "./components/CorrentistaList";
import SeguridadList from "./components/SeguridadList";
import { useAuth0 } from '@auth0/auth0-react'; 
import Inicio from "./components/Inicio";
import { useEffect, useRef, useState } from 'react';

import AsientoVentaForm from './components/AsientoVentaForm';
import AsientoCompraForm from './components/AsientoCompraForm';
import AsientoList from './components/AsientoList';
import ContabilidadList from './components/ContabilidadList';
import ContabilidadForm from './components/ContabilidadForm';
import CuentaList from './components/CuentaList';
import CuentaForm from './components/CuentaForm';
import SireComparacionForm from "./components/SireComparacionForm";
import SireComprasPage from "./modules/sire/compras";
import SeguridadContabilidad from "./components/SeguridadContabilidad";
import AsientoListPrev from "./components/AsientoListPrev";
import AsientoDetalleList from "./components/AsientoDetalleList";
import AsientoDetalleForm from "./components/AsientoDetalleForm";
import ReportesList from "./components/ReportesList";
import AsientoGenericoForm from "./components/AsientoGenericoForm";

import AdminVentaList from "./components/Admin/venta/list/AdminVentaList";
import AdminProductoList from "./components/Admin/producto/AdminProductoList";
import AdminProductoGrupoList from "./components/Admin/producto/AdminProductoGrupoList";
import AdminProductoForm from "./components/Admin/producto/AdminProductoForm";
import AdminVentaForm from "./components/Admin/venta/form/AdminVentaForm";
import AdminEquipoList from "./components/Admin/AdminEquipoList";
import AdminEquipoForm from "./components/Admin/AdminEquipoForm";
import AdminPuntoVentaUsuarioList from "./components/Admin/AdminPuntoVentaUsuarioList";
import AdminPuntoVentaUsuarioForm from "./components/Admin/AdminPuntoVentaUsuarioForm";
import AdminProductoFormPrecio from "./components/Admin/producto/AdminProductoFormPrecio";

// 👇 Importa el ConfirmProvider
//import { DialogProvider } from "./components/Admin/AdminConfirmDialogProvider";
import { AdminConfirmDialogProvider } from "./components/Admin/AdminConfirmDialogProvider";
import AdminStockList from "./components/Admin/stock/list/AdminStockList";

import NavSideBar from "./components/NavSideBar";
import Header from './components/Header'; // Importa el nuevo componente
import AdminStockForm from "./components/Admin/stock/form/AdminStockForm";
import AdminVentaRepDet from "./components/Admin/venta/reports/AdminVentaRepDet";
import AdminStockRepDet from "./components/Admin/stock/reports/AdminStockRepDet";
import AdminStockRepInventario from "./components/Admin/stock/reports/AdminStockRepInventario";
import AdminStockRepKardex from "./components/Admin/stock/reports/AdminStockRepKardex";
import AdminVentaRepRef from "./components/Admin/venta/reports/AdminVentaRepRef";
import AdminVentaPresupuestoList from "./components/Admin/presupuestos/AdminVentaPresupuestoList";
import AdminVentaPresupuestoForm from "./components/Admin/AdminVentaPresupuestoForm";
import AdminVentaPresupuestoNuevoForm from "./components/Admin/presupuestos/AdminVentaPresupuestoNuevoForm";
import AdminCorrentistaHabitualList from "./components/Admin/venta/habituales/AdminCorrentistaHabitualList";
import AdminVentaResumenSunatList from "./components/Admin/venta/list/AdminVentaResumenSunatList";
import TrEncomiendaList from "./components/Admin/transporte/encomienda/TrEncomiendaList";
import TrGremEncomiendaList from "./components/Admin/transporte/encomienda/TrGremEncomiendaList";
import TrEncomiendaEntregaList from "./components/Admin/transporte/encomienda/entrega/TrEncomiendaEntregaList";
import TrBoletosList from "./components/Admin/transporte/TrBoletosList";
import TrManifiestoList from "./components/Admin/transporte/manifiesto/TrManifiestoList";
import TrPlacaList from "./components/Admin/transporte/TrPlacaList";
import TrLicenciaList from "./components/Admin/transporte/TrLicenciaList";
import TrZonaList from "./components/Admin/transporte/TrZonaList";
import AdminPuntoVentaList from "./components/Admin/AdminPuntoVentaList";
import TrRutaList from "./components/Admin/transporte/TrRutaList";
import TrEncomiendaDashboardMockup from "./components/Admin/transporte/dashboard/TrEncomiendaDashboardMockup";
import TrCajaMovimientoList from "./components/Admin/transporte/caja/TrCajaMovimientoList";
import TrReporteSireList from "./components/Admin/transporte/sunat/TrReporteSireList";
import AdminMenuConfigList from "./components/Admin/menu/AdminMenuConfigList";
import AdminMenuPermisosList from "./components/Admin/menu/AdminMenuPermisosList";
import palette from "./theme/palette";

function AppLayout(props) {
  const {user, isAuthenticated } = useAuth0();
  const location = useLocation();
  const isEntregasRoute = location.pathname.startsWith("/ad_transporteentregas");
  const isEncomiendaRoute = location.pathname.startsWith("/ad_transportesencomienda") || location.pathname.startsWith("/ad_transporte/");
  const isGremRoute = location.pathname.startsWith("/ad_transportegrem");
  const isBoletosRoute = location.pathname.startsWith("/ad_transportesboletos");
  const isCajaRoute = location.pathname.startsWith("/ad_transportecaja");
  const isVentaRoute = location.pathname.startsWith("/ad_venta/");
  const isPresupuestoRoute = location.pathname.startsWith("/ad_ventapresupuesto/");
  const isPanoramicRoute = isEntregasRoute || isEncomiendaRoute || isGremRoute || isBoletosRoute || isCajaRoute || isVentaRoute || isPresupuestoRoute;
  const [panoramicMode, setPanoramicMode] = useState(() => (
    typeof window !== "undefined" && (
      window.location.pathname.startsWith("/ad_transporteentregas") ||
      window.location.pathname.startsWith("/ad_transportesencomienda") ||
      window.location.pathname.startsWith("/ad_transporte/") ||
      window.location.pathname.startsWith("/ad_transportegrem") ||
      window.location.pathname.startsWith("/ad_transportesboletos") ||
      window.location.pathname.startsWith("/ad_transportecaja") ||
      window.location.pathname.startsWith("/ad_venta/") ||
      window.location.pathname.startsWith("/ad_ventapresupuesto/")
    )
  ));

  const previousPanoramicRoute = useRef(isPanoramicRoute);
  const claveMenuPanoramico = (pathname) => {
    if (pathname.startsWith("/ad_ventapresupuesto/")) return "presupuestos";
    if (pathname.startsWith("/ad_venta/")) return "ventas";
    if (pathname.startsWith("/ad_transporteentregas")) return "entregas";
    if (pathname.startsWith("/ad_transportesencomienda") || pathname.startsWith("/ad_transporte/")) return "encomiendas";
    if (pathname.startsWith("/ad_transportegrem")) return "grem";
    if (pathname.startsWith("/ad_transportesboletos")) return "boletos";
    if (pathname.startsWith("/ad_transportecaja")) return "caja";
    return "";
  };
  const handleNavigatePanoramicMenu = (targetKey) => {
    const currentKey = claveMenuPanoramico(location.pathname);

    if (currentKey && currentKey === targetKey) {
      setPanoramicMode((current) => !current);
      return;
    }

    setPanoramicMode(true);
  };

  useEffect(() => {
    if (previousPanoramicRoute.current !== isPanoramicRoute) {
      setPanoramicMode(isPanoramicRoute);
      previousPanoramicRoute.current = isPanoramicRoute;
    }
  }, [isPanoramicRoute]);

  useEffect( ()=> {
    if (isAuthenticated && user && user.email) {
      // lógica de verificación (NavBar)
    }  
  },[isAuthenticated, user]);

  return (
      <Box sx={{ display: 'flex',
                 gap: { xs: 0, md: panoramicMode ? 0 : 2 },
                 alignItems: { xs: 'stretch', md: 'flex-start' },
                 backgroundColor: palette.bg,
                 color: palette.text,
                 p: { xs: 0, md: panoramicMode ? 0 : 2 },
                 boxSizing: 'border-box',
                 minHeight: "100vh", // 🔹 ocupa toda la altura disponible
              }}
      >
          {/* Sidebar fijo a la izquierda */}
          <NavSideBar 
            idAnfitrion={props.idAnfitrion}
            idInvitado={props.idInvitado}
            rubro={props.rubro}
            super={props.super}
            panoramicMode={panoramicMode}
            onTogglePanoramic={isPanoramicRoute ? () => setPanoramicMode((current) => !current) : undefined}
            onNavigatePanoramic={handleNavigatePanoramicMenu}
          />


          {/* Contenido principal con margen izquierdo */}
          <Container
            component="main"
            maxWidth={false}
            disableGutters
            sx={{
              flex: 1,
              p: 0,
              marginLeft: 0,
              width: '100%',
              minHeight: { xs: '100vh', md: panoramicMode ? '100vh' : 'calc(100vh - 32px)' },
              height: { xs: 'auto', md: panoramicMode ? '100vh' : 'calc(100vh - 32px)' },
              maxHeight: { xs: 'none', md: panoramicMode ? '100vh' : 'calc(100vh - 32px)' },
              minWidth: 0,
              boxSizing: 'border-box',
              overflowX: 'hidden',
              overflowY: { xs: 'visible', md: 'auto' },
              scrollbarWidth: 'thin',
              scrollbarColor: `${palette.surfaceAlt} transparent`,
              '&::-webkit-scrollbar': {
                width: 10,
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: palette.surfaceAlt,
                borderRadius: 999,
                border: `3px solid ${palette.navBg}`,
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: palette.muted,
              },
              backgroundColor: palette.navBg,
              border: 'none',
              borderRadius: { xs: 0, md: panoramicMode ? 0 : 3 },
              boxShadow: { xs: 'none', md: panoramicMode ? 'none' : palette.shadowSoft },
            }}
          >
            <Header
              panoramicMode={panoramicMode}
              onExitPanoramic={() => setPanoramicMode(false)}
            />
            <Box
              className="app-content-shell"
              sx={{
                px: { xs: 1, sm: 2, md: panoramicMode ? 1.5 : 3 },
                pt: { xs: 1, md: panoramicMode ? 0.5 : 2 },
                pb: { xs: 1, md: panoramicMode ? 1 : 2 },
              }}
            >
            <Routes>
              {/* tus rutas originales, sin cambios */}

              <Route path="/ad_ventapresupuesto/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminVentaPresupuestoList idAnfitrion={props.idAnfitrion} idInvitado={props.idInvitado} super={props.super} />} />
              <Route path="/ad_ventapresupuesto/:id_anfitrion/:id_invitado/:periodo/:documento_id/new" element={<AdminVentaPresupuestoNuevoForm />} />
              <Route path="/ad_ventapresupuesto/:id_anfitrion/:id_invitado/:periodo/:documento_id/:comprobante/edit" element={<AdminVentaPresupuestoNuevoForm />} />
              <Route path="/ad_ventapresupuesto/:id_anfitrion/:id_invitado/:periodo/:documento_id/:comprobante/view" element={<AdminVentaPresupuestoForm />} />
              <Route path="/ad_transportesencomienda/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrEncomiendaList idAnfitrion={props.idAnfitrion} idInvitado={props.idInvitado} super={props.super} supervisor={props.supervisor} panoramicMode={panoramicMode} />} />
              <Route path="/sire/compras/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<SireComprasPage />} />
              <Route path="/ad_transportesire/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrReporteSireList />} />
              <Route path="/ad_transporterdiencomienda/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminVentaResumenSunatList modo="transporte" origen={["TRANS_ENCOMIENDA", "TRANS_BOLETO"]} titulo="Historial RDI y CDR - Encomiendas - Boletos" rutaBase="/ad_transporterdiencomienda" />} />
              <Route path="/ad_transportegrem/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrGremEncomiendaList panoramicMode={panoramicMode} />} />
              <Route path="/ad_transporte/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrEncomiendaList idAnfitrion={props.idAnfitrion} idInvitado={props.idInvitado} super={props.super} supervisor={props.supervisor} panoramicMode={panoramicMode} />} />
              <Route path="/ad_transportedashboard/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrEncomiendaDashboardMockup />} />
              <Route path="/ad_transporteentregas/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrEncomiendaEntregaList panoramicMode={panoramicMode} supervisor={props.supervisor} />} />
              <Route path="/ad_transportecaja/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrCajaMovimientoList />} />
              <Route path="/ad_transportesboletos/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrBoletosList panoramicMode={panoramicMode} super={props.super} supervisor={props.supervisor} />} />
              {/* Manifiesto de pasajeros. El punto de venta viaja en el query porque no
                  forma parte de la ruta y hace falta para crear el manifiesto. */}
              <Route path="/ad_transportemanifiesto/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrManifiestoList />} />
              <Route path="/ad_puntoventa/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminPuntoVentaList />} />
              <Route path="/ad_transportepuntos/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminPuntoVentaList />} />
              <Route path="/ad_transporterutas/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrRutaList />} />
              <Route path="/ad_transporteplacas/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrPlacaList />} />
              <Route path="/ad_transportelicencias/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrLicenciaList />} />
              <Route path="/ad_transportezonas/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<TrZonaList />} />
              <Route path="/ad_menuconfig/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminMenuConfigList super={props.super} />} />
              <Route path="/ad_menupermisos/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminMenuPermisosList super={props.super} />} />

              <Route path="/ad_ventarepref/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminVentaRepRef />} />
              <Route path="/ad_correntistahabitual/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminCorrentistaHabitualList />} />
              <Route path="/ad_ventaresumensunat/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminVentaResumenSunatList />} />

              <Route path="/ad_stockrepkardex/:id_anfitrion/:periodo/:documento_id/:dia/:id_producto/:id_almacen" element={<AdminStockRepKardex />} />
              <Route path="/ad_stockrepinventario/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminStockRepInventario />} />
              <Route path="/ad_stockrepdet/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminStockRepDet />} />
              <Route path="/ad_stock/:id_anfitrion/:id_invitado/:documento_id" element={<AdminStockList />} />
              <Route path="/ad_stock/:id_anfitrion/:id_invitado/:periodo/:documento_id/new" element={<AdminStockForm />} />
              <Route path="/ad_stock/:id_anfitrion/:id_invitado/:periodo/:documento_id/:comprobante/:comprobante_ref" element={<AdminStockForm />} />
              <Route path="/ad_stock/:id_anfitrion/:id_invitado/:periodo/:documento_id/:comprobante/view" element={<AdminStockForm />} />

              <Route path="/ad_equipo/:id_anfitrion/:id_invitado/:documento_id" element={<AdminEquipoList />} />          
              <Route path="/ad_equipo/:id_anfitrion/:id_invitado/:documento_id/new" element={<AdminEquipoForm />} />          
              <Route path="/ad_equipo/:id_anfitrion/:id_invitado/:documento_id/:id_equipo/edit" element={<AdminEquipoForm />} />

              <Route path="/ad_puntoventausuario/:id_anfitrion/:id_invitado" element={<AdminPuntoVentaUsuarioList />} />
              <Route path="/ad_puntoventausuario/:id_anfitrion/:id_invitado/new" element={<AdminPuntoVentaUsuarioForm />} />
              <Route path="/ad_puntoventausuario/:id_anfitrion/:id_invitado/:documento_id/:id_punto_venta/:id_invitado_grupo/edit" element={<AdminPuntoVentaUsuarioForm />} />
              <Route path="/ad_puntoventausuario/:id_anfitrion/:id_invitado/:id_invitado_grupo/edit" element={<AdminPuntoVentaUsuarioForm />} />
              <Route path="/ad_usuariogrupo/:id_anfitrion/:id_invitado" element={<AdminPuntoVentaUsuarioList />} />
              <Route path="/ad_usuariogrupo/:id_anfitrion/:id_invitado/new" element={<AdminPuntoVentaUsuarioForm />} />
              <Route path="/ad_usuariogrupo/:id_anfitrion/:id_invitado/:documento_id/:id_punto_venta/:id_invitado_grupo/edit" element={<AdminPuntoVentaUsuarioForm />} />
              <Route path="/ad_usuariogrupo/:id_anfitrion/:id_invitado/:id_invitado_grupo/edit" element={<AdminPuntoVentaUsuarioForm />} />

              <Route path="/ad_ventarepdet/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminVentaRepDet />} />
              <Route path="/ad_venta/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AdminVentaList panoramicMode={panoramicMode} />} />
              <Route path="/ad_venta/:id_anfitrion/:id_invitado/:periodo/:documento_id/new" element={<AdminVentaForm />} />
              <Route path="/ad_venta/:id_anfitrion/:id_invitado/:periodo/:documento_id/:comprobante/:comprobante_ref" element={<AdminVentaForm />} />
              <Route path="/ad_venta/:id_anfitrion/:id_invitado/:periodo/:documento_id/:comprobante/view" element={<AdminVentaForm />} />

              <Route path="/ad_producto/:id_anfitrion/:id_invitado/:documento_id" element={<AdminProductoList />} />
              <Route path="/ad_productogrupo/:id_anfitrion/:id_invitado/:documento_id" element={<AdminProductoGrupoList />} />
              <Route path="/ad_producto/:id_anfitrion/:id_invitado/:documento_id/new" element={<AdminProductoForm />} />          
              <Route path="/ad_producto/:id_anfitrion/:id_invitado/:documento_id/:id_producto/edit" element={<AdminProductoForm />} />
              <Route path="/ad_productoprecio/:id_anfitrion/:id_invitado/:documento_id/:id_producto/:unidades/:accion" element={<AdminProductoFormPrecio />} />

              <Route path="/reporte/:id_anfitrion/:id_invitado" element={<ReportesList />} />

              <Route path="/asientodet/:id_anfitrion/:id_invitado/:documento_id/:periodo/:id_libro/:num_asiento/new" element={<AsientoDetalleForm />} />
              <Route path="/asientodet/:id_anfitrion/:id_invitado/:documento_id/:periodo/:id_libro/:num_asiento/:item/edit" element={<AsientoDetalleForm />} />
              
              <Route path="/asientodet/:id_anfitrion/:id_invitado/:documento_id/:periodo/:id_libro/new" element={<AsientoDetalleList />} />
              <Route path="/asientodet/:id_anfitrion/:id_invitado/:documento_id/:periodo/:id_libro/:num_asiento/edit" element={<AsientoDetalleList />} />

              <Route path="/asiento/:id_anfitrion/:id_invitado/:periodo/:documento_id" element={<AsientoList />} />
              
              <Route path="/asientog/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/new" element={<AsientoGenericoForm />} />
              <Route path="/asientog/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/:num_asiento/edit" element={<AsientoGenericoForm />} /> 

              <Route path="/asientoc/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/new" element={<AsientoCompraForm />} />
              <Route path="/asientoc/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/:num_asiento/edit" element={<AsientoCompraForm />} /> 
              <Route path="/asientoc/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/:num_asiento/clonar" element={<AsientoCompraForm />} /> 

              <Route path="/asientov/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/new" element={<AsientoVentaForm />} />
              <Route path="/asientov/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/:num_asiento/edit" element={<AsientoVentaForm />} /> 
              <Route path="/asientov/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro/:num_asiento/clonar" element={<AsientoVentaForm />} /> 

              <Route path="/contabilidades/:id_anfitrion/:id_invitado" element={<ContabilidadList />} />
              <Route path="/contabilidad/:id_anfitrion/new" element={<ContabilidadForm />} />
              <Route path="/contabilidad/:id_anfitrion/:documento_id/:tipo/edit" element={<ContabilidadForm />} />
              
              <Route path="/cuentas/:id_usuario/:documento_id" element={<CuentaList />} />
              <Route path="/cuenta/:id_usuario/:documento_id/new" element={<CuentaForm />} />
              <Route path="/cuenta/:id_usuario/:documento_id/edit" element={<CuentaForm />} />

              <Route path="/correntista" element={<CorrentistaList />} />          
              <Route path="/correntista/new" element={<CorrentistaForm />} />
              <Route path="/correntista/:id/edit" element={<CorrentistaForm />} /> 

              <Route path="/:id_anfitrion/:id_invitado" element={<Inicio />} />

              <Route path="/seguridad/:id_anfitrion" element={<SeguridadList />} />          
              <Route path="/seguridad/contabilidades/:id_anfitrion/:id_invitado" element={<SeguridadContabilidad />} />          
              <Route path="/sirecomparacion/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro" element={<SireComparacionForm />} /> 
              <Route path="/asientogenerador/:id_anfitrion/:id_invitado/:periodo/:documento_id/:id_libro" element={<AsientoListPrev />} /> 
            </Routes>
            </Box>
          </Container>
      </Box>
  );
}

function App(props) {
  return (
    <BrowserRouter>
      <AdminConfirmDialogProvider>
        <AppLayout {...props} />
      </AdminConfirmDialogProvider>
    </BrowserRouter>
  );
}

export default App;
